var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.671.025a8.671 8.671 0 1 0 0 17.343 8.571 8.571 0 0 0 4.113-1.016 2.478 2.478 0 0 0 .322.322l2.478 2.478a2.527 2.527 0 1 0 3.568-3.568l-2.478-2.478a2.478 2.478 0 0 0-.4-.322 8.555 8.555 0 0 0 1.09-4.113A8.681 8.681 0 0 0 8.7 0zm0 2.478a6.165 6.165 0 0 1 6.194 6.194 6.213 6.213 0 0 1-1.635 4.261l-.074.074a2.478 2.478 0 0 0-.322.322 6.2 6.2 0 0 1-4.187 1.561 6.194 6.194 0 1 1 0-12.388z"
  })));
};
export default SvgSearch;